import mockLocationValues from "./locations.json";

const mockLocations = (query = "") => {
    const locations = {
        object: "suggestions",
        data: []
    };

    const locationValueLowered = query.toLowerCase();

    if (query) {
        locations.data = mockLocationValues.filter((location) => {
            const locationValue = location.text.toLowerCase();
            return locationValue.includes(locationValueLowered) ? location : null;
        });
    } else {
        locations.data = mockLocationValues;
    }

    return locations;
};

// Resolves to The Muse's Office
const mockUserLocation = () => ({
    city: "New York",
    region: "New York",
    country: "United States",
    dma: "New York, NY",
    lat: 40.7524,
    lon: -73.9875,
    accuracy_radius: 10
});

export { mockLocations, mockUserLocation };
